var map;
var markers = [];
var radius_circle;
var geocoder;
var infowindow = [];
var activeInfoWindow = null;
var $retail_stores  = $('.partial#retail-stores');
var $online_stores  = $('.partial#online-stores');	

var StoresMap = {	
	stores  : [],
	markers : null, 
	zoom  	: 7,
	mapPin	: null,

	init:function(){   

		StoresMap.mapPin = {
			url			: MAP_MARKER,
			origin 		: new google.maps.Point(0, 0),
			labelOrigin : new google.maps.Point(17,20)
		};

		activeInfoWindow = null;
		StoresMap.stores = [];
		$('.info-box').each(function(){
			StoresMap.stores.push($(this).data());			
		});		
		StoresMap.setZoom();
		StoresMap.initMap();
		/*
		if ( navigator.geolocation ) {                        
            navigator.geolocation.getCurrentPosition(StoresMap.initGeolocationMap);
        }else{
            StoresMap.initMap();
        } 
        */
	}, 

	cm : null,

	codeAddress:function(zipCode , country){	
		
		var $this = this;
		try {
			$('.map-canvas').css('opacity', 0.5);
			var latitude 	= $('.info-box[data-id="'+country+'"]').data('latitude') ;
			var longitude 	= $('.info-box[data-id="'+country+'"]').data('longitude') ;
			var store_country = $('.info-box[data-id="'+country+'"]').data('country') ;
			
			geocoder.geocode({ 'address': zipCode +' '+ store_country}, function (results, status) {		

				if(latitude && longitude){
					var storeLtLng =  new google.maps.LatLng(latitude, longitude) ;
					var bounds = new google.maps.LatLngBounds();
				}else{
					var storeLtLng = results[0].geometry.location;
					var bounds = results[0].geometry.viewport;
				}			
				
				

				if (status == google.maps.GeocoderStatus.OK) {

					
						map.setCenter(storeLtLng );
					

					if ( country.toLowerCase() != 'united states' && country.toLowerCase()!='canada'  ) {
						
						bounds.extend(storeLtLng);

						map.fitBounds(bounds);	

						if(latitude && longitude){
							StoresMap.setZoom();
							map.setZoom(StoresMap.zoom);
						}
				 
 						var name 		= $('.info-box[data-id="'+country+'"]').data('name') 
						var address 	= $('.info-box[data-id="'+country+'"]').data('address') 
						
						var city 		= $('.info-box[data-id="'+country+'"]').data('city') 
						var zip 		= $('.info-box[data-id="'+country+'"]').data('zip') 
						var cc 			= $('.info-box[data-id="'+country+'"]').data('country') 
						var state 		= $('.info-box[data-id="'+country+'"]').data('state') 
						var phone 		= $('.info-box[data-id="'+country+'"]').data('phone') 
						var email 		= $('.info-box[data-id="'+country+'"]').data('email') 
						var website 	= $('.info-box[data-id="'+country+'"]').data('website') || ''
 		
 						var phone_btn =  phone!=='' ? '<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="tel:'+phone+'" target="_blank">Call now</a>' : '';
						var email_btn=  email!=='' ? '<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="mailto:'+email+'" target="_blank">Send email </a>' : '';
						var website_btn=  website!=='' ? '<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="'+website+'" target="_blank">Website</a>' : '';
						
						var contentString = 
						'<div class="scrollFix" style="overflow: hidden;">\
						<div class="name" data-id="'+country+'" data-id="'+country+'">'+ name + '</div>\
						<div class="address" style=\"word-wrap: break-word;\">'+ address+' '+city+' '+zip+' '+state+' '+cc+'<br>'+phone_btn+email_btn+website_btn+'</div>\
						</div>';	

						
						if ($this.cm) {
							try {
								$this.cm.setMap(null);		
							} catch (e) { }
							
						}
						

						if(latitude && longitude){
							var myLatLng = new google.maps.LatLng(latitude, longitude) ;
						}else{
							var myLatLng = results[0].geometry.location;
						}

						$this.cm 		= new google.maps.Marker({
							position : myLatLng,
							map 	 : map,
							title 	 : '' +  $('.info-box[data-id="'+country+'"]').data('name') + '', 
							zIndex 	 : 1,
							icon 	 : StoresMap.mapPin,						
						});

						google.maps.event.addListener($this.cm, 'click', StoresMap.getInfoCallback(map, contentString, country, $this.cm));
							
							
					}
					
					//StoresMap.setMarkers(map);
				    setTimeout(function(){
                		$('.info-box[data-id="' + $('select[name="country"]').val() + '"]').removeClass('hidden');
	                },500);
					
					
				} else {
					alert("Geocode was not successful for the following reason: " + status);
				} 
			});	
			$('.map-canvas').css('opacity',1);
		}
		catch(err) {
			$('.map-canvas').css('opacity',1);
		}
	 
    },

	initMap:function(){
		var myLatlng = new google.maps.LatLng( 
			StoresMap.stores[0].latitude, 
			StoresMap.stores[0].longitude
		);
		var options = {
			zoom 				: StoresMap.zoom,
			//styles 				: MAP_STYLING,
			center 				: myLatlng,
	
			fullscreenControl	: false,
			streetViewControl 	: false,
			mapTypeControl 		: false,
			zoomControl 		: true,
			scrollwheel			: false,
			gestureHandling		: "cooperative",
			mapTypeId 			: google.maps.MapTypeId.ROADMAP
		};
	    geocoder 	= new google.maps.Geocoder();
		map 		= new google.maps.Map($('#map')[0], options);

		//StoresMap.setMarkers(map);

        $( ".stores .retail-stores .info-boxes .info-box" ).mouseenter(function() {
		 	 StoresMap.markers[$(this).data('id')].setAnimation(google.maps.Animation.BOUNCE);	
		 	 StoresMap.markers[$(this).data('id')].setIcon(MAP_MARKER_ACTIVE);	 
		});

		$( ".stores .retail-stores .info-boxes .info-box" ).mouseleave(function() {
		 	 StoresMap.markers[$(this).data('id')].setAnimation(null);
		 	 StoresMap.markers[$(this).data('id')].setIcon(MAP_MARKER);	 
		});	

	    google.maps.event.addListener(map, 'bounds_changed', function () {	    	
	      	StoresMap.setMarkers(map);
	    });	    
	    StoresMap.setMarkers(map);
	},

	initGeolocationMap:function(position){	

		var options = {
			center 				: {
                lat: position.coords.latitude, 
                lng: position.coords.longitude
            },
			zoom 				: StoresMap.zoom,
			styles 				: MAP_STYLING,			
			fullscreenControl	: false,
			streetViewControl 	: false,
			mapTypeControl 		: false,
			zoomControl 		: false,
			mapTypeId 			: google.maps.MapTypeId.ROADMAP
		};	

	    geocoder 	= new google.maps.Geocoder();
		map 		= new google.maps.Map($('#map')[0], options);

		//StoresMap.setMarkers(map);
	    google.maps.event.addListener(map, 'bounds_changed', function () {
			StoresMap.setMarkers(map);
			
			
	    });
	    
	},
	

	setMarkers:function(map){		
 
	    if(StoresMap.markers !== null){	    	
	        for(var i in StoresMap.markers){	        	
	            StoresMap.markers[i].setMap(null);
	        }	      	        
	    }
	    StoresMap.markers = null;
	    var bounds = map.getBounds();
	    if (typeof bounds !== "undefined") {
		    
	        var ne     = bounds.getNorthEast();
	        var sw     = bounds.getSouthWest();	    


		    $('.retail-stores .info-box').addClass('hidden');

		    for (var i in StoresMap.stores) {

		    	
		        var point = StoresMap.stores[i];

	        	if( $('select[name="country"]').val().toLowerCase() === point.country.toLowerCase() || $('select[name="country"]').val() === point.id ){

	        		
	        		 if (point.latitude != '' && point.longitude != ''
			        	&& Number(point.latitude) < Number(ne.lat())
		                && Number(point.latitude) > Number(sw.lat())
		                && Number(point.longitude) < Number(ne.lng())
		                && Number(point.longitude) > Number(sw.lng())

		                ) {			

			        	var id 			= (typeof point.id !== "undefined")? 		point.id 		: 0;
			            var counter 	= (typeof point.counter !== "undefined")?	point.counter 	: 0;
			            var name 		= (typeof point.name !== "undefined")?		point.name 		: '';
			            var address 	= (typeof point.address !== "undefined")?	point.address 	: '';
			            var city 		= (typeof point.city !== "undefined")?		point.city		: '';
			            var state 		= (typeof point.state !== "undefined")?		point.state		: '';
			            var zip 		= (typeof point.zip !== "undefined")?		point.zip 		: '';
			            var phone 		= (typeof point.phone !== "undefined")?		point.phone 		: '';
			            var email 		= (typeof point.email !== "undefined")?		point.email 		: '';
			            var latitude 	= (typeof point.latitude !== "undefined")?	point.latitude 	: '';
			            var longitude 	= (typeof point.longitude !== "undefined")?	point.longitude : '';			  
						var website 	= (typeof point.website !== "undefined")?	point.website : '';		

						var phone_btn =  phone!=='' ? '<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="tel:'+phone+'" target="_blank">Call now</a>' : '';
						var email_btn=  email!=='' ? '<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="mailto:'+email+'" target="_blank">Send email </a>' : '';
						var website_btn=  website!=='' ? '<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="'+website+'" target="_blank">Website</a>' : '';
						

						var contentString = 
						'<div class="scrollFix" style="overflow: hidden;">\
						<div class="name" data-id="'+point.id+'">'+ name + '</div>\
						<div class="address" style=\"word-wrap: break-word;\">'+ address+' '+city+' '+state+' '+zip+'<br>'+phone_btn+email_btn+website_btn+'<a  class="btn btn-default d-block" style="padding: 5px;height: auto; line-height:1.3 ;margin-top:5px;" href="https://maps.google.com?saddr=Current+Location&daddr='+latitude+','+longitude+'" target="_BLANK" class="directions">Directions</a></div>\
						</div>';				



						var myLatLng 	= new google.maps.LatLng( point.latitude, point.longitude);
			            var marker 		= new google.maps.Marker({
			                position : myLatLng,
			                map 	 : map,
			                title 	 : point.address, 
			                zIndex 	 : Number(i), 
							icon 	 : StoresMap.mapPin,						
			            });

						google.maps.event.addListener( marker, 'click', StoresMap.getInfoCallback(map, contentString , id , marker) );
						
						var $item = $('.retail-stores .info-box[data-id="' + point.id + '"]');	


						//$('.info-box[data-id="' + id + '"]').removeClass('hidden');

						if( $('select[name="country"]').val() ){

							if ( point.country.toLowerCase() != 'united states' && point.country.toLowerCase()!='canada'  ) {
								$('.retail-stores .info-box[data-id="' + $('select[name="country"]').val() + '"]').removeClass('hidden');
							}else{
								$('.info-box[data-id="' + id + '"][data-country="' + $('select[name="country"]').val() + '"]').removeClass('hidden');
							}

							
						}else{
							$item.removeClass('hidden');
						}	
						
						if(StoresMap.markers == null){
							StoresMap.markers = [];
						}				
						StoresMap.markers[id] = marker;

								
						$item.data('marker', marker)
						

						
						
			        } else if(point.latitude === '' && point.longitude ===  '' && point.country.toLowerCase() != 'united states' && point.country.toLowerCase()!='canada'){
			        	$('.retail-stores .info-box[data-id="' + $('select[name="country"]').val() + '"]').removeClass('hidden');
			        }
		    	}

		        
		        
		    }	  
		} 
		//$('.info-box[data-id="' 	+ $('select[name="country"]').val()+'"]').removeClass('hidden');
		//$('.info-box[data-id!="' 	+ $('select[name="country"]').val() + '"]').addClass('hidden');
		//

	},

	getInfoCallback:function(map, content, id , marker){
		google.maps.InfoWindow.prototype.opened = false;	
		if (typeof infowindow[id] == "undefined") {
			infowindow[id] = new google.maps.InfoWindow( { content: content } );      
		}

		google.maps.event.addListener(infowindow, 'domready', function() {
		    var iwOuter 	 = $('.gm-style-iw');
			var iwCloseBtn 	 = iwOuter.next();
			var iwBackground = iwOuter.prev();
			iwCloseBtn.css({display: 'none'});
			iwBackground.children(':nth-child(2)').css({'opacity' : '1','background-color':'#fff'});
			iwBackground.children(':nth-child(4)').css({'opacity' : '1','background-color':'#fff'});
		});     

		return function() {
			
			if(infowindow[id].opened){
				infowindow[id].close(map , marker);				
				marker.setIcon(StoresMap.mapPin);
			    infowindow[id].opened = false;
			}else{
				infowindow.forEach(function(i) {
			     	i.close(map, marker);
			    	i.opened = false; 	
			  	}); 


				infowindow[id].close(map,marker);
				infowindow[id].open(map,this);
				marker.setIcon(StoresMap.mapPin);				
				infowindow[id].opened = true;
			}
			google.maps.event.addListener( map , 'click', function() {
				infowindow[id].close(map,marker);
				marker.setIcon(StoresMap.mapPin);
			    infowindow[id].opened = false;


			    
			});		
		};
	},

	openBox:function($this){ 
		var id  			= $this.data('id');
		var $the_marker 	= StoresMap.markers[$this.data('id')];
		var $the_infowindow = infowindow[id];
		var $online_stores 	= $('.partial#online-stores');		
        if (typeof map == "undefined") {

            google.maps.event.addListener( map, 'idle', function () {
                setTimeout(function(){
                	
                    $the_infowindow.open( map ,  $the_marker );
                    map.setCenter(new google.maps.LatLng( $this.data('latitude') , $this.data('longitude') ));
                },500);
            }); 
     
        }else{

        	if(typeof $the_infowindow.opened !== "undefined" && $the_infowindow.opened){
				$the_infowindow.close(map , $the_marker);								
			    $the_infowindow.opened = false;

			}else{
				infowindow.forEach(function(i) {
			     	i.close(map, $the_marker);
			    	i.opened = false; 	
			  	});			  	
			  	setTimeout(function(){   		  
					$the_infowindow.open( map, $the_marker );				
					$the_infowindow.opened = true;	
                },500);		
			}
            map.setCenter(new google.maps.LatLng($this.data('latitude'), $this.data('longitude')));
        }        
    }, 

	setZoom:function(){
	 
	    // visible_distance -> in meters
	    // img_width -> in pixels
	    var visible_distance = Math.floor(Number($('.stores-filters select[name="miles_range"]').val()) * 1.60934 * 1000);

	    if(Number($('.stores-filters select[name="miles_range"]').val()) !== 0){

	    	var img_width = Math.floor(Number($('.stores .block-right').innerWidth()));    	
		    visible_distance = Math.abs(visible_distance); 
		    var equator_length = 40075016; // in meters
		    // for an immage of 256 pixel pixel
		    var zoom256 = Math.log(equator_length/visible_distance)/Math.log(2);    
		    // adapt the zoom to the image size
		    var x = (Math.log(img_width/256)/Math.log(2));
		    StoresMap.zoom = Math.floor(zoom256 + x);  

	    }else{
	    	StoresMap.zoom = 7;  	    	
	    }  
	}

};  



var StoresFilters = {
	init:function(){
		var $the_form = $('form.stores-filters');
		var $name;
		var $value;

		$('select[name="country"]').on('change' , function(){
			if($(this).val().toLowerCase() != 'united states' && $(this).val().toLowerCase() != 'canada'){
				$('.zip').hide();
				$('.range').hide();
			}else{
				$('.zip').show();
				$('.range').show();

			}
		});
 
		$the_form.on('submit',function(e){			
			var $retail_stores  = $('.partial#retail-stores');
			var $online_stores  = $('.partial#online-stores');	
			var $d 				= $the_form.serializeArray();				
			var $type 			= $the_form.find('[name="type"]:checked').val();
			var $type 			= 'retail';	
			var zip 			= null;
			var country 		= null; 
			var $zip_field = $('#stores_filters_zip');
			var $range_field = $('select[name="miles_range"]');
			
		

			for (var i = 0; i < $d.length; i++) {			    
				$value = $d[i]['value'];
				$name  = $d[i]['name'];
				$online_stores.attr('data-'+$name,$value);
				if( $type == 'retail' ){
					if($d[i]['name'] == 'miles_range' && $d[i]['value']!==''){ 						
						StoresMap.setZoom();
						map.setZoom(StoresMap.zoom);
					}
					if($d[i]['name'] == 'zip' && $d[i]['value']!==''){				
						zip = $d[i]['value'];						
					}
					if($d[i]['name'] == 'country' && $d[i]['value']!==''){				
						country = $d[i]['value'];
					}
				}	
			} 
			if (country.toLowerCase() == 'united states' || country.toLowerCase() == 'canada' ) {
				
			} else {
				$zip_field.val('');
				zip = '';
			}



			if (country.toLowerCase() == 'united states' ||  country.toLowerCase() == 'canada'   ) {
				if( $zip_field.val() == ''){ 												
					$zip_field.addClass('error');
				}else{
					$zip_field.removeClass('error');
				}
				if($range_field.val() == ''){ 												
					$range_field.addClass('error');
				}else{
					$range_field.removeClass('error');
				}
	
	
	
				if( $range_field.val() == '' || $zip_field.val() =='' ){ 				
					return false;
				}
	
			}

			



			if( $type == 'retail' ){
				//$online_stores.hide();
				$('.widget.stores').addClass('map-visible'); 
				$('.map-canvas').addClass('show');
				$('.map-canvas').show();										
				if (zip || country) {
					
					StoresMap.codeAddress( zip , country);
				}	

			} else {		
				
				$retail_stores.hide();
				$('.map-canvas').hide();	
				$online_stores.show();
				$('.map-canvas').hide();

			}

			return false;
			
		}); 
	}
};
